'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _usageData = require('./usage-data.component');

var _usageData2 = _interopRequireDefault(_usageData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.usageDataForm', []).component('usageData', _usageData2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/usage-data/usage-data.module.js